import { Landmark } from "lucide-react";
import { useMenuAccess } from "@/app/access";
import { SettledRules } from "@/components/ui/SettledRules";

/**
 * Quy tắc của Bút toán kế toán — chốt 20/09/2026 theo chuẩn, khách bác lại được.
 *
 * Khác mười bốn mục vàng trước ở một điểm quan trọng: bốn quy tắc này vốn đã đúng chuẩn, thứ còn thiếu KHÔNG phải cách làm mà là
 * DỮ LIỆU KẾ TOÁN của Hisense — pháp nhân, hệ thống tài khoản, mã thuế, dung sai đối soát ba bên, tỷ lệ giá thành. Vì vậy màn này
 * chưa ghi được bút toán nào trên production (có 12 tài khoản nhưng 0 kỳ kế toán), và điều đó được nói thẳng trong manual chứ
 * không giấu sau một nhãn vàng. Các câu hỏi còn lại nằm ở mục 32 bộ câu hỏi.
 */
export const GL_RULES_SETTLED = ["mapping", "period", "matching", "costing", "authority"] as const;

export function FinanceRules() {
  return <SettledRules ns="gl" rules={GL_RULES_SETTLED} icon={Landmark} />;
}

/**
 * Cùng bộ giải quyền với máy chủ (ô tick menu Tài chính).
 *
 * Trước 20/09/2026 cấu hình sổ chặn cứng theo vai trò quản trị viên ở 12 chỗ; chủ dự án chốt đưa về ô tick, nên kế toán trưởng
 * được cấp ô Duyệt là khoá / mở kỳ và sửa hệ thống tài khoản được mà không cần tài khoản quản trị.
 */
export function useFinanceAccess() {
  return useMenuAccess("finance");
}
